import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { yupResolver } from '@hookform/resolvers/yup';
import Button from 'Components/Button';
import Card from 'Components/Card';
import ControllerDatePicker from 'Components/ControllerDatePicker';
import ControllerInput from 'Components/ControllerInput';
import ProgressBar from 'Components/ProgressBar';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { setPagos } from '../../../redux/slices';
import PagosService from 'Services/Http/Pagos.service';
import { PagosSchema } from 'Services/yup/form';
import { formatCurrency } from 'Utils/Functions';
import ModalComponent from 'Components/Modal';

export const Depositos = (props) => {
  const { folioCredito, edit = true } = props;
  const [rowsData, setRowsData] = useState([]);
  const [itemActive, setItemActive] = useState(null);
  const { rows, totalDeposito, faltante, montoTotal } = useSelector((state) => state.pagos.pagos);
  const [titleReject, setTitleReject] = useState('');
  const [loader, setLoader] = useState(false);
  const [stateModal, setStateModal] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    if (folioCredito) {
      getListDepositos();
    }
  }, [folioCredito]);
  useEffect(() => {
    if (rows) {
      createRows();
    }
  }, [rows]);
  const getListDepositos = async () => {
    setLoader(true);
    try {
      const response = await PagosService.getPagos(folioCredito);
      dispatch(setPagos(response.data));
      setLoader(false);
    } catch (e) {
      console.log(e);
      setLoader(false);
    }
  };

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm({
    defaultValues: {
      montoPago: '',
      fechaDeposito: ''
    },
    resolver: yupResolver(PagosSchema)
  });

  const createRows = () => {
    let data = rows.map((item, index) => (
      <tr
        key={`pagos-row-${folioCredito}-${index}`}
        className="odd:bg-white even:bg-blue-100 border-b hover:bg-blue-300 hover:cursor-pointer">
        <td className="px-6 py-4">{item.idPago}</td>
        <td className="px-6 py-4">{item.numeroDePago}</td>
        <td className="px-6 py-4">{formatCurrency(item.montoPago)}</td>
        <td className="px-6 py-4">{moment(item.fechaDeposito).format('DD/MM/YYYY')}</td>
        <td className="px-6 py-4">{moment(item.created_at).format('DD/MM/YYYY')}</td>
        <td className="px-6 py-4">{item.motivo}</td>
        <td className="px-6 py-4">
          {edit ? (
            item.valid ? (
              <FontAwesomeIcon
                icon={['fa', 'trash']}
                color="red"
                size="lg"
                onClick={() => deleteEvent(item)}
              />
            ) : (
              <FontAwesomeIcon icon={['fa', 'ban']} color="red" size="lg" />
            )
          ) : (
            ''
          )}
        </td>
      </tr>
    ));
    setRowsData(data);
  };

  const deleteDeposito = async (item) => {
    try {
      setStateModal(false);
      await PagosService.deletePago(itemActive.idPago, item);
      await getListDepositos();
    } catch (e) {
      console.log(e);
    }
  };

  const deleteEvent = async (item) => {
    try {
      const monto = formatCurrency(item.montoPago);
      const fecha = moment(item.fechaDeposito).format('DD/MM/YYYY');
      const label = `Deseas eliminar el pago ${monto} de fecha ${fecha}`;
      setTitleReject(label);
      setItemActive(item);
      setStateModal(true);
    } catch (e) {
      console.log(e);
    }
  };

  const saveDeposito = async (form) => {
    setLoader(true);
    try {
      await PagosService.savePagos(folioCredito, form);
      await getListDepositos();
      reset();
      setLoader(false);
    } catch (e) {
      console.log(e);
      setLoader(false);
    }
  };

  const changeState = (state) => {
    setStateModal(state);
  };
  const refresh = async () => {
    getListDepositos();
  };
  return (
    <Card title="Depositos">
      <div className="my-3">
        <Button iconprefix={['fa', 'arrows-rotate']} onClick={() => refresh()} />
      </div>
      <div className="relative sm:rounded-lg">
        {edit ? (
          <div className="flex my-5 gap-3 justify-start items-end">
            <div>
              <div>Monto Deposito</div>
              <ControllerInput
                control={control}
                name="montoPago"
                error={errors?.montoPago}
                placeholder="Monto Pago"
                onlyNumbers={true}
              />
            </div>
            <div>
              <div>Fecha Deposito</div>
              <ControllerDatePicker
                control={control}
                name="fechaDeposito"
                error={errors?.fechaDeposito}
                placeholder="Fecha de deposito"
              />
            </div>
            <div>
              <Button label="Autorizar" color="success" onClick={handleSubmit(saveDeposito)} />
            </div>
          </div>
        ) : (
          ''
        )}
        <div className="flex flex-col md:flex-row my-3 md:grid md:grid-flow-col md:grid-cols-3 justify-stretch">
          <div>
            <div>Total deposito: </div>
            <div className="font-semibold">{formatCurrency(totalDeposito)}</div>
          </div>
          <div>
            <div>Monto Faltante: </div>
            <div className="font-semibold">{formatCurrency(faltante)}</div>
          </div>
          <div>
            <div>Monto Total: </div>
            <div className="font-semibold">{formatCurrency(montoTotal)}</div>
          </div>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-sm text-left rtl:text-right text-black ">
            <thead className="text-xs text-white uppercase bg-blue-500">
              <tr>
                <th scope="col" className="px-6 py-3">
                  Id Deposito
                </th>
                <th scope="col" className="px-6 py-3">
                  Numero de pago
                </th>
                <th scope="col" className="px-6 py-3">
                  Monto
                </th>
                <th scope="col" className="px-6 py-3">
                  Fecha Deposito
                </th>
                <th scope="col" className="px-6 py-3">
                  Fecha Captura
                </th>
                <th scope="col" className="px-6 py-3">
                  Observaciones
                </th>
                <th scope="col" className="px-6 py-3"></th>
              </tr>
            </thead>
            <tbody>{rowsData}</tbody>
          </table>
        </div>
        {loader ? <ProgressBar /> : ''}
      </div>
      <ModalComponent
        show={stateModal}
        typeModal="motivo"
        labelReject={'Eliminar'}
        changeState={changeState}
        actionOK={deleteDeposito}
        title={titleReject}
      />
    </Card>
  );
};

Depositos.propTypes = {
  folioCredito: PropTypes.number.isRequired,
  edit: PropTypes.bool.isRequired
};
